<template>
  <div>
    <div v-if="isAllEmployees" class="flex justify-center items-center rounded-full bg-gray-400 text-gray-50" :class="avatarSize">
      <div class="w-5 h-5">
        <UsersIcon />
      </div>
    </div>
    <img
      v-else-if="!!imageURL && !loadError"
      @load="isLoaded = true"
      @error="loadError = true"
      v-show="isLoaded"
      :src="imageURL"
      :alt="employee.name"
      :class="[ avatarSize, isLoaded && 'inline-block rounded-full max-w-none' ]"
    >
    <p
      v-if="(!imageURL || !isLoaded || loadError) && !isAllEmployees"
      class="py-1 font-medium rounded-full flex items-center justify-center bg-primary-400 text-white cursor-default"
      :class="avatarSize"
    >
      {{ initials }}
    </p>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import { UsersIcon } from "@heroicons/vue/24/solid"

export default {
  name: "EmployeeAvatar",
  components: {
    UsersIcon
  },
  props: {
    employee: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: "md"
    },
    isUser: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      avatar: null,
      isLoaded: false,
      loadError: false
    }
  },
  computed: {
    ...mapState(["headers"]),
    ...mapGetters([
      "getEmployeesUserId",
      "getEmployeeAvatars",
      "getUserId",
      "getUserAvatar"
    ]),
    userId() {
      return this.isUser ? this.employee.id : this.getEmployeesUserId[this.employee.id]
    },
    imageURL() {
      if (this.avatar) return this.avatar
      else if (this.userId === this.getUserId) return this.getUserAvatar?.image_url
      else return this.getEmployeeAvatars[this.userId]
    },
    initials() {
      if (!this.employee.name) return
      let substrings = this.employee.name?.split(" ")
      substrings = substrings.filter(x => x.length > 0)
      let firstAndLast = substrings.length > 1 ? [substrings[0], substrings.pop()] : [substrings[0]]
      let initials = firstAndLast.map(x => x[0].toUpperCase()).join("")
      return initials
    },
    isAllEmployees() {
      return this.employee.id === "" && this.employee.name.toLowerCase() === "all"
    },
    avatarSize() {
      return {
        "h-5 w-5 text-[9px]": this.size === "sm",
        "h-7 w-7 text-xs": this.size === "md",
        "h-11 w-11 text-lg": this.size === "lg",
        "h-52 w-52 text-7xl": this.size === "7xl",
        "h-72 w-72 text-9xl": this.size === "9xl"
      }
    }
  },
  watch: {
    employee(val, oldVal) {
      if (val !== oldVal) this.avatar = null
    },
  }
}
</script>